import { Component, OnInit } from '@angular/core';
import { ImagenesService } from './services/imagenes.service';
import { Cintillo } from '../../../app/entities/cintillo/imagenes';
import { HomeSlider } from '../../shared/data/slider';

@Component({
  selector: 'app-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss']
})
export class ImagesComponent implements OnInit {
  public informacion: Cintillo;
  public showButtons: boolean;
  constructor(private imagesService: ImagenesService){}
  
  ngOnInit(): void {
    this.getPromociones()
    this.showButtons = false;
  }

  getPromociones() {
    this.imagesService.getPromociones().subscribe((result:Cintillo)=> {
      this.informacion = result;
      this.showButtons = true;
      }
    )
  }

  public HomeSliderConfig: any = HomeSlider;

}
